import React, { useEffect } from 'react';
import Chip from '~components/atoms/Chip';
import Table from '~components/molecules/Table';
import { MetalTypeEnum, SerialNumberStatusEnum } from '~utils/enums';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

const SerialNumberSearchTable = () => {
    const dispatch = useAppDispatch();
    const serialNumberListing = useAppSelector(state => state.gold.serialNumber.serialNumberListing.data);
    const isLoading = useAppSelector(state => state.gold.loadings.getSerialNumberListing);
    const serialNumberListingIndex = useAppSelector(state => state.gold.serialNumber.serialNumberListing.index);

    useEffect(() => {
        dispatch(combinedActions.goldGetSerialNumberListingAttempt());
    }, [serialNumberListingIndex]);

    const tableHeader = [
        'PRODUCT NAME',
        'STATUS',
        'PHYSICAL WEIGHT',
        'SERIAL NUMBER',
        'BRANCH CODE',
        'BRANCH NAME',
        'CUSTOMER NAME',
        'CIF NUMBER',
    ];

    const tableData = serialNumberListing.map(item => {
        const {
            productName,
            status,
            metalType,
            physicalGoldWeight,
            physicalSilverWeight,
            serialNo,
            branchCode,
            branchName,
            customerName,
            CIFNo,
        } = item;

        const physicalWeight =
            metalType === MetalTypeEnum.Gold
                ? physicalGoldWeight
                : physicalSilverWeight;

        const renderSerialNumberStatusChip = () => {
            switch (status) {
                case SerialNumberStatusEnum.Unsold:
                    return (
                        <Chip
                            type='success'
                            label='Unsold'
                        />
                    );

                case SerialNumberStatusEnum.Sold:
                    return (
                        <Chip
                            type='inactive'
                            label='Sold'
                        />
                    );

                default:
                    return null;
            }
        };

        return [
            productName,
            renderSerialNumberStatusChip(),
            physicalWeight || 'N/A',
            serialNo,
            branchCode,
            branchName,
            customerName || '-',
            CIFNo || '-',
        ];
    });

    return (
        <Table
            header={tableHeader}
            body={tableData}
            isLoading={isLoading}
        />
    );
};

export default SerialNumberSearchTable;
